import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import useCopyWidget from "../../../hooks/useCopyWidget";
import { EditorPanelContext } from "../../../containers/editor/EditorPanel";
import { isUnsuportedWidgetsInSelectionForClipBoardAction } from "../../../_helpers/utils";

let style = Object.assign({}, global);

const Copy = props => {
  let { rightContextMenu, updateRightContextMenu, metadata } = useContext(EditorContext);
  let { keyBoardEvent, updateKeyBoardEvent } = useContext(EditorPanelContext);

  useCopyWidget();

  const [isMac, setIsMac] = useState();

  const copyMethod = () => {
    updateKeyBoardEvent({ ...keyBoardEvent, copy: true });
    if (props.rightContext)
      updateRightContextMenu({
        ...rightContextMenu,
        enable: false,
      });
  };

  useEffect(() => {
    let isMacOS = /Mac/i.test(navigator.platform) || /Macintosh/i.test(navigator.userAgent);
    setIsMac(isMacOS);
  }, []);

  return (
    <li
      className={cx({
        [style["custom-tooltip"]]: !props.rightContext,
      })}>
      <span
        className={cx(style["toolset-action"], {
          [style["disabled"]]: isUnsuportedWidgetsInSelectionForClipBoardAction(metadata.activeWidgetId),
        })}
        onClick={copyMethod}>
        <Icon icon="ui-clone2" />
        {props.rightContext && (
          <>
            Copy {isMac && <span>Cmd+C</span>}
            {!isMac && <span>Ctrl+C</span>}
          </>
        )}
      </span>
      {!props.rightContext && <div className={style["custom-tooltip-content"]}>Copy</div>}
    </li>
  );
};

Copy.propTypes = {
  rightContext: PropTypes.bool,
};

export default Copy;
